/** Inclusive ISO bounds so date-only and full ISO `sold_date` strings both match. */
export const soldDateQueryBounds = (start: Date, end: Date) => ({
  startBound: start.toISOString().slice(0, 10),
  endBound: `${end.toISOString().slice(0, 10)}T23:59:59.999Z`,
})

export const DASHBOARD_QUERY_ROOT = 'dashboard' as const

export const dashboardSoldQueryKey = (startMs: number, endMs: number) =>
  [DASHBOARD_QUERY_ROOT, 'sold', startMs, endMs] as const
